import cardPopover from './common/popover.js'
import cardEventPopoverMixins from '../mixins/card-event-popover'
const cardComponents = require.context('./', true, /index.vue$/)

export function installReportCard() {
  try {
    return cardComponents.keys().map(fileName => {
      const componentConfig = cardComponents(fileName)
      const { name, ...resetOptions } = componentConfig.default ? componentConfig.default : componentConfig
      return {
        name,
        ...cardEventPopoverMixins, // 混入的方法
        components: {
          cardPopover
        },
        extends: resetOptions
      }
    })
  } catch (e) {
    return []
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-report-form/card/install.js